import React from 'react';
import Fenix from '@pedidosya/web-fenix/contexts/FenixContext';
import { usePublicEnv, ContextType } from '@app/shared/contexts/PublicEnv';
import type { PropsWithChildren, FC } from 'react';

export const FenixProvider: FC<PropsWithChildren> = ({ children }) => {
  const env = usePublicEnv() as ContextType;
  return <Fenix config={{ revamp: env?.revamp ? env?.revamp : false }}>{children}</Fenix>;
};
